import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'
import Scroll from '@components/Scroll'
import Actions from './Actions'
import ProjectsTable from './ProjectsTable'

class ProjectsPipelineView extends Component {
  static propTypes = {
    projectsPipelineStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.loadInitialData()
  }

  loadInitialData () {
    this.props.projectsPipelineStore.filter()
  }

  renderError (error) {
    if (error) return <Error />
  }

  renderLoader () {
    return <Spinner />
  }

  render () {
    const {
      loading,
      error,
      projects,
      revenueSum,
      costSum,
      totalMargin
    } = this.props.projectsPipelineStore
    if (error) {
      return this.renderError(error)
    }
    if (loading) {
      return this.renderLoader()
    }

    return (
      <div className='revenues-view'>
        <Scroll>
          <div style={{ overflowX: 'auto', height: 'calc(100vh - 75px)' }}>
            <div
              className='project-wrapper'
              style={{ minWidth: '1000px', paddingLeft: 25, paddingRight: 25 }}
            >
              <div className='details-header'>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Projects pipeline</h1>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{totalMargin}</h1>
                    <span>Margin</span>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{costSum}</h1>
                    <span>Cost</span>
                  </div>
                </div>
                <div className='floating'>
                  <div>
                    <h1>{revenueSum}</h1>
                    <span>Revenue</span>
                  </div>
                </div>
              </div>
              <div className='invoice-wrapper animate-intro'>
                {projects.length > 0 ? (
                  <div>
                    <div className='actions-wrapper clearfix'>
                      <Actions />
                    </div>
                    <ProjectsTable projects={projects} />
                  </div>
                ) : (
                  <Error
                    label={'No results match the current filter parameters'}
                  />
                )}
              </div>
            </div>
          </div>
        </Scroll>
      </div>
    )
  }
}

export default inject('projectsPipelineStore')(observer(ProjectsPipelineView))
